import React, { useRef, Suspense, useEffect, useState } from "react";
import axios from "axios-jsonp-pro";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import getBrowserFingerprint from "get-browser-fingerprint";
import { useForm } from "react-hook-form";
import Popup from "./Elements/AlertPopup";
import { Base64 } from 'js-base64';

const UniqueCode = () => {
  const {
    register,
    setError,
    setFocus,
    formState: { errors },
    handleSubmit,
    clearErrors,
  } = useForm();

  const { ref } = register("code");
  const refs = useRef();
  const unquiebutton = useRef();
  const fingerprint = getBrowserFingerprint();
  const { t } = useTranslation(["UniqueLandingPageAgency"]);
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [agencyName, setAgencyName] = useState("");
  const [agencyData, setAgencyData] = useState(null); // temporary data storage
const [resforPopUp, setResonse] = useState(null);
  // ✅ Verify agency
  const verifyagencybyCode = async (data) => {
    try {
      const lanCode = localStorage.getItem("lanCode");

      const res = await axios.post(
        process.env.REACT_APP_API_ENDPOINT + "/varifyagencycode",
        {
          code: data.code,
          language: lanCode,
        }
      );

      // Store only code & PID immediately (for tracking)
      // localStorage.setItem("PID", Base64.encode(fingerprint + "P2"));
      // localStorage.setItem("aGencyCcod", data.code);

      // ✅ Process response
      if (res.data && Array.isArray(res.data) && res.data.length > 0) {
        const first = res.data[0];
        const welcome = first.welcomeMessage || "";

        // Save data temporarily until popup submit
        setAgencyData({
          agencyId: first.agencyId,
          agencyEmail: first.agencyEmail,
          code: data.code,
        });

        // If welcome message exists → show popup
        if (welcome.trim() !== "") {
          setAgencyName(welcome);
          setResonse(first);
          setShowPopup(true);
          return;
        }
      }

      // ✅ If no popup needed, redirect directly
      navigate("/agency");
    } catch (error) {
      if (error.response) {
        setError("code", { type: "unique" });
        refs.current.className = "w-100 px-3 py-2 mb-5 redFocus";
        setFocus("code");

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "customEvent",
          eventCategory: "InValidCode",
          eventAction: "Click",
          eventLabel: "startTraining",
          eventValue: data.code,
        });
      }
    }
  };

  // ✅ Handle popup submit (Yes button)
  const handlePopupSubmit = () => {
    if (agencyData) {
      // Store after confirmation
      localStorage.setItem("aGencyID", agencyData.agencyId);
      localStorage.setItem("agencyEmail", agencyData.agencyEmail);
      localStorage.setItem("aGencyCcod", agencyData.code);
      localStorage.setItem("AID", Base64.encode(fingerprint + "A2"));
    }

    setShowPopup(false);
    navigate("/agency");
    setTimeout(() => window.location.reload(), 100);
  };

  const closeModal = () => {
    setShowPopup(false);
    navigate("/agency");
  };

  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const onNo = () => {
    setShowPopup(false);
    setShowErrorMessage(true);
    navigate("/agency");

    setTimeout(() => {
    setShowErrorMessage(false);
    }, 10000);
  }

  // ✅ Geo-location behavior (unchanged)
  // useEffect(() => {
  //   const checkCountry = async () => {
  //     try {
  //       const res = await axios.jsonp(
  //         "https://web.diageoagegate.com/api/country.php"
  //       );

  //       const clients = document.querySelectorAll(".clients1");
  //       if (clients.length) {
  //         clients.forEach((client) => {
  //           client.style.display = res.countryCode === "TR" ? "none" : "block";
  //         });
  //       }
  //     } catch (error) {
  //       console.warn("Geo check failed:", error);
  //     }
  //   };

  //   checkCountry();
  // }, []);

  return (
    <Suspense fallback={null}>
      {/* Popup */}
      <Popup
        isOpen={showPopup}
        closeModal={closeModal}
        onYes={handlePopupSubmit}
        aggencyName={agencyName}
        resforPopUp={resforPopUp}
        onNo={onNo}
      />

      {/* Header Section */}
      <section className="header2 theme-space px-lg-5 autofocus">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-9 col-lg-9">
              <div className="text-wrapper">
                {Object.values(t("topContent", { returnObjects: true })).map(
                  (item) =>
                    item.fieldType === "h1" && item.value !== "" ? (
                      <h1 key={item.id} className="mb-5">
                        <ReactMarkdown components={{ p: React.Fragment, h1: React.Fragment, h2: React.Fragment, h3: React.Fragment, h4: React.Fragment, h5: React.Fragment, h6: React.Fragment }}>
                          {item.value}
                        </ReactMarkdown>
                      </h1>
                    ) : null
                )}
                
                {Object.values(t("topContent", { returnObjects: true })).map(
                  (item) =>
                    item.fieldType === "plain_text" && item.value !== "" ? (
                      <p key={item.id} className="col-12 col-md-7 col-lg-7">
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {item.value}
                        </ReactMarkdown>
                      </p>
                    ) : null
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="theme-space px-lg-5">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-6 col-lg-5">
              <div className="text-wrapper">
                
                {showErrorMessage && 
                <div class="alert alert-danger" role="alert" style={{padding : "5px 10px"}}>
                  Please enter the valid Unique code assigned to your agency.
                </div>
                }

                <form onSubmit={handleSubmit(verifyagencybyCode)}>
                  {Object.values(
                    t("bottomContent", { returnObjects: true })
                  ).map((item) =>
                    item.fieldType === "input_text" && item.value !== "" ? (
                      <div key={item.id} className="position-relative">
                        <label htmlFor="uniquedid" className="mb-3 uniqueid">
                          <ReactMarkdown components={{ p: React.Fragment }}>
                            {item.value}
                          </ReactMarkdown>
                        </label>

                        <input
                          id="uniquedid"
                          {...register("code", {
                            required: true,
                            onChange: (e) => {
                              if (e.target.value === "") {
                                refs.current.className =
                                  "w-100 px-3 py-2 mb-5";
                                unquiebutton.current.disabled = true;
                              } else {
                                refs.current.className =
                                  "w-100 px-3 py-2 mb-5";
                                unquiebutton.current.disabled = false;
                                clearErrors("code");
                              }
                            },
                          })}
                          ref={(e) => {
                            ref(e);
                            refs.current = e;
                          }}
                          className="w-100 px-3 py-2 mb-5"
                          placeholder={item.placeholder}
                          autoComplete="off"
                        />

                        {errors.code?.type === "unique" && (
                          <span className="error_uniquecode">
                            {item.errorText}
                          </span>
                        )}
                      </div>
                    ) : null
                  )}

                  {Object.values(
                    t("bottomContent", { returnObjects: true })
                  ).map((item) =>
                    item.fieldType === "button" &&
                    item.id === "button_uniqueIdentifer_1" &&
                    item.value !== "" ? (
                      <button
                        aria-label={item.value}
                        ref={(ref) => (unquiebutton.current = ref)}
                        disabled={true}
                        key={item.id}
                        className="faq-button"
                      >
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {item.value}
                        </ReactMarkdown>
                      </button>
                    ) : null
                  )}
                </form>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-7"></div>
          </div>
        </div>
      </section>
    </Suspense>
  );
};

export default UniqueCode;
